import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import store from 'Redux/store';
import focusMenuLink from 'Layout/NavBar/MegaMenu/focus-menu-link';

export default function BundlesLink({ setMegaMenuTab, megaMenuTab }) {
  const [delayHandler, setDelayHandler] = useState(null);

  const clickButton = () => {
    setMegaMenuTab(megaMenuTab === '' ? 'bundles' : '');
    focusMenuLink('bundles-gamebundles');

    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'SecondaryNavLinks', value: '/bundle', context: 'Bundle' },
    });
  };

  const handleMouseEnter = () => {
    setDelayHandler(setTimeout(() => {
      setMegaMenuTab('bundles');
    }, 200));
  };

  const handleMouseLeave = () => {
    clearTimeout(delayHandler);
    setMegaMenuTab('');
  };

  return (
    <div className="store-link-button">
      <Link
        aria-expanded={megaMenuTab === 'bundles'}
        aria-controls="MegaMenu_bundles"
        aria-haspopup="true"
        aria-label="bundles, dropdown"
        to="/bundle"
        className="secondary-nav-link"
        onClick={() => { clickButton(); }}
        onMouseEnter={() => { handleMouseEnter(); }}
        onMouseLeave={() => { handleMouseLeave(); }}
      >
        <FormattedMessage id="bundles-link.name" defaultMessage="Bundles" />
        <div className="link-arrow" />
      </Link>
    </div>
  );
}

BundlesLink.propTypes = {
  setMegaMenuTab: PropTypes.func,
  megaMenuTab: PropTypes.string,
};

BundlesLink.defaultProps = {
  setMegaMenuTab: () => { },
  megaMenuTab: '',
};
